import { Logger } from '../../logger/interface/Logger';
import { Locker } from '../interface/Locker';
import { Lock } from '../interface/Locker/Lock';
import { Secondary } from '../interface/Locker/Secondary';
import { PrimaryMap } from '../interface/Locker/PrimaryMap';
export class LockerWS extends EventTarget implements Locker {
  //#region Constants
  private readonly URL: string = 'wss://192.168.7.2:1880/control';
  private readonly PUB_TOPIC_OPEN_LOCK: string =
    'control/service/actions/openlock';
  private readonly PUB_TOPIC_GET_LOCKERS_MAP: string =
    'control/service/config/getlockersmap';
  private readonly PUB_TOPIC_OPEN_ALL_LOCKS: string =
    'control/service/actions/openalllocks';
  private readonly SUB_TOPIC_COMMAND_ANSWER: string =
    'control/service/actions/commandanswer';
  private readonly SUB_TOPIC_LOCK_OPENED: string =
    'control/service/actions/lockopened';
  private readonly SUB_TOPIC_LOCK_CLOSED: string =
    'control/service/actions/lockclosed';
  private readonly SUB_TOPIC_LOCKER_STATUS: string =
    'control/service/status/locker';
  private readonly SUB_TOPIC_GET_LOCKERS_MAP_ANSWER: string =
    'control/service/config/getlockersmapanswer';
  private readonly GET_LOCKERS_MAP_ANSWER_PAYLOAD: string = '3000';
  //#region Properties
  private readonly logger: Logger;
  private boolConnected: boolean = false;
  private ws: WebSocket;

  constructor(logger: Logger) {
    super();
    this.logger = logger;
    this.ws = new WebSocket(this.URL);
    this.setWS();
  }
  private setWS() {
    this.ws.onclose = () => {
      this.boolConnected = false;
      console.log('Disconnected');
      this.onDisconnected();
    };
    this.ws.onmessage = (event) => {
      this.handleWSMessage(event.data);
    };
    this.ws.onerror = (event) => {
      console.error(event);
    };
    this.ws.onopen = () => {
      this.boolConnected = true;
      console.log('Connected');
      this.onConnected();
    };
  }
  private onLockOpened(lock: Lock) {
    console.log(lock);
    const connectedEvent = new CustomEvent('lockOpened', { detail: lock });
    this.dispatchEvent(connectedEvent);
  }
  private onLockClosed(lock: Lock) {
    const connectedEvent = new CustomEvent('lockClosed', { detail: lock });
    this.dispatchEvent(connectedEvent);
  }
  public isConnected(): boolean {
    return this.boolConnected;
  }
  public reconnect(): void {
    console.log('Reconnecting WebSocket...');
    if (this.ws) {
      this.ws.close();
    }
    this.ws = new WebSocket(this.URL);
    this.setWS();
  }
  public async openLockAsync(lock: Lock): Promise<void> {
    try {
      if (this.isConnected()) {
        const payload = JSON.stringify(lock);
        await this.ws.send(
          JSON.stringify({
            topic: this.PUB_TOPIC_OPEN_LOCK,
            payload: payload,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  public async openAllLocksAsync(secondary: Secondary): Promise<void> {
    try {
      if (this.isConnected()) {
        const payload = JSON.stringify(secondary);
        await this.ws.send(
          JSON.stringify({
            topic: this.PUB_TOPIC_OPEN_ALL_LOCKS,
            payload: payload,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  public async getLockerMapAsync(): Promise<void> {
    try {
      if (this.isConnected()) {
        await this.ws.send(
          JSON.stringify({
            topic: this.PUB_TOPIC_GET_LOCKERS_MAP,
            payload: this.GET_LOCKERS_MAP_ANSWER_PAYLOAD,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  public addEventListener(
    type: string,
    callback: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions | undefined
  ): void {
    super.addEventListener(type, callback, options);
  }
  public removeEventListener(
    type: string,
    callback: EventListenerOrEventListenerObject | null,
    options?: boolean | EventListenerOptions | undefined
  ): void {
    super.removeEventListener(type, callback, options);
  }
  public dispatchEvent(event: Event): boolean {
    return super.dispatchEvent(event);
  }
  private onConnected() {
    const connectedEvent = new Event('connection');
    this.dispatchEvent(connectedEvent);
  }
  private onDisconnected() {
    const disconnectedEvent = new Event('disconnection');
    this.dispatchEvent(disconnectedEvent);
  }
  private handleWSMessage(event: any) {
    let json = JSON.parse(event);
    console.log(json);
    switch (json.topic) {
      case this.SUB_TOPIC_LOCK_OPENED:
        this.onLockOpened(json.payload as Lock);
        return;
      case this.SUB_TOPIC_LOCK_CLOSED:
        this.onLockClosed(json.payload as Lock);
        return;
      case this.SUB_TOPIC_GET_LOCKERS_MAP_ANSWER:
        const primaryMap = json.payload as PrimaryMap;
        console.log(primaryMap);
        return;
    }
  }
}
